import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Alert, Breadcrumb, Card, Col, Collapse, Descriptions, Divider, Row, Skeleton, Space, Table, Typography } from 'antd';
import { CheckCircleOutlined, FolderOutlined, InfoCircleOutlined, RadiusUpleftOutlined, SafetyCertificateOutlined, SettingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getRegulatoryInfoReact } from '../../services/regulationService';
import { Tooltip } from 'antd';
import mapImage from '../../assets/images/map.jpg';
import certificateService from '../../services/certificateService';
import { useSelector } from 'react-redux';
import Disclaimer from '../../components/regulatoryLibrary/disclaimer';
import { decodeBase64, getCountryCombination } from '../../utils/commonUtil';
import WatermarkComponent from '../../components/common/watermark';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const RegulationInformation = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const [objRegulatoryInfo, setObjRegulatoryInfo] = useState();
    const genRegInfoItems = [];
    const procedureItems = [];
    const labelingInfoItems = [];
    const certInfoItems = [];
    const { regUniqueId } = useParams();
    const [loading, setLoading] = useState(false);
    const [tooltipContent, setTooltipContent] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const applicationData = useSelector((state) => state.applicationData);
    const skeletonItem = {
        label: _jsx(Skeleton.Input, { active: true, size: 'default' }),
        children: _jsx(Skeleton.Input, { active: true, size: 'default' }),
        span: { xl: 4, xxl: 4 }
    };
    const loadingItems = [];
    for (let i = 0; i < 10; i++) {
        loadingItems.push(skeletonItem);
    }
    const formatDate = (date) => {
        const formattedDate = date === null || date === undefined
            ? null
            : dayjs(date, 'DD/MM/YYYY hh:mm:ss').format('DD-MMM-YYYY');
        return formattedDate;
    };
    const DownloadDoc = (strDocRefId) => {
        if (!strDocRefId) {
            console.error('Document reference ID is undefined.');
            return;
        }
        certificateService
            .getFileDocument(strDocRefId)
            .then((res) => {
            if (!res || !res.bytefileData || !res.strDocName) {
                console.error('Invalid response from certificateService.getFileDocument');
                return;
            }
            const docName = res.strDocName;
            const bytefileData = new Uint8Array(res.bytefileData);
            let mimeType = 'application/*'; // Default MIME type
            if (docName.endsWith('.pdf')) {
                mimeType = 'application/pdf';
            }
            else if (docName.endsWith('.zip')) {
                mimeType = 'application/zip';
            }
            else if (docName.endsWith('.jpg') || docName.endsWith('.jpeg')) {
                mimeType = 'image/jpeg';
            }
            else if (docName.endsWith('.png')) {
                mimeType = 'image/png';
            } // Add more MIME types as needed
            const blob = new Blob([bytefileData], { type: mimeType });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = docName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // Cleanup the object URL after the download
            URL.revokeObjectURL(downloadUrl);
        })
            .catch((error) => {
            console.error('Error downloading the document:', error);
        });
    };
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 4)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolRequirementsRequirementPage) ||
            !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId) {
            commonService
                .logUserActivity((_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId, UserActivity.CP__Requirement_Summ_Detail_Visited);
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        setLoading(true);
        if (regUniqueId) {
            const decodedText = decodeBase64(regUniqueId);
            const splitText = decodedText.split('-');
            const objRegDetailsInfo = {
                strRegulationId: splitText[0],
                intCompanyID: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID,
                intVersion: splitText[1],
                lstLuCompany: [{
                        intId: (_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID
                    }]
            };
            getRegulatoryInfoReact(objRegDetailsInfo).then((res) => {
                var _a;
                setObjRegulatoryInfo(getCountryCombination(res, (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.lstobjAccessScreenCombination, applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails));
                setLoading(false);
            });
        }
    }, [regUniqueId]);
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strRegulatorName) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Regulatory Name" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strRegulatorName,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTechProdRegulated) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Technology/Product Regulated" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTechProdRegulated,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandVoluntary) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Mandatory Voluntary" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandVoluntary,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strApplLicenseHolderReq) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Application/License Holder Requirements" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strApplLicenseHolderReq,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTestSampleNoCondition) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Test sample No./Condition" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTestSampleNoCondition,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLeadTime) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Lead time" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLeadTime,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strCertBody) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Certification Body (if any)" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strCertBody,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTestInCountryCBAccept) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Test in-country/ CB Acceptance" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTestInCountryCBAccept,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabAccredReq) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Lab Accreditation Requirements" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabAccredReq,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strNeedApproval) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Approval is Needed for?" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strNeedApproval,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProductMarkingReq) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Product Marking Requirement" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProductMarkingReq,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strFactoryInspection) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Factory Inspection" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strFactoryInspection,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strPreshipmentInspecMarketSurveil) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Preshipment inspection/Market Surveillance" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strPreshipmentInspecMarketSurveil,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.dtValidFrom) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Valid From" }),
            children: formatDate(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.dtValidFrom),
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.dtValidTo) {
        genRegInfoItems.push({
            label: _jsx(Typography.Text, { children: "Valid To" }),
            children: formatDate(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.dtValidTo),
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProcedureDetails) {
        procedureItems.push({
            label: _jsx(Typography.Text, { children: "Procedure Details" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProcedureDetails,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strModularApproval) {
        procedureItems.push({
            label: _jsx(Typography.Text, { children: "Modular Approval" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strModularApproval,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMRAProgram) {
        procedureItems.push({
            label: _jsx(Typography.Text, { children: "MRA Program (if any)" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMRAProgram,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandLogoMarkingProduct) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Mandatory Logo / Marking on product" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandLogoMarkingProduct,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLogoMarking) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Logo / Marking" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLogoMarking,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabelColorSizeFontReq) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Label size, color, font requirement" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabelColorSizeFontReq,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabelingRules) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Labeling rules" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabelingRules,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strELabeling) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "e-labeling" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strELabeling,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if ((_e = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLabelSample) === null || _e === void 0 ? void 0 : _e.strDocName) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Label sample" }),
            children: (_jsx("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    DownloadDoc(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strLabelSampleDocRefId);
                }, children: (_f = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLabelSample) === null || _f === void 0 ? void 0 : _f.strDocName })),
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandStatementUserManual) {
        labelingInfoItems.push({
            label: _jsx(Typography.Text, { children: "Mandatory Statement on User's manual" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMandStatementUserManual,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMarkReqProductSmall) {
        labelingInfoItems.push({
            label: (_jsx(Typography.Text, { children: "Marking requirement if product is too small" })),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMarkReqProductSmall,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strUserManualLabelLangAppl) {
        labelingInfoItems.push({
            label: (_jsx(Typography.Text, { children: "User's manual / label - Language on Application" })),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strUserManualLabelLangAppl,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strUserManualLabelLangImport) {
        labelingInfoItems.push({
            label: (_jsx(Typography.Text, { children: "User's manual / label - Language on Importation" })),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strUserManualLabelLangImport,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strCertValidityYearMonth) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Certificate Validity period; renewable?" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strCertValidityYearMonth,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strVariantSeriesFamilyModelCert) {
        certInfoItems.push({
            label: (_jsx(Typography.Text, { children: "Variant/series/family models on certificate" })),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strVariantSeriesFamilyModelCert,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strReCertification) {
        certInfoItems.push({
            label: (_jsx(Typography.Text, { children: "Re-certification (new/extension, year/month)" })),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strReCertification,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMultipleBrandTradeCert) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Multiple brand/trade mark on certificate" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strMultipleBrandTradeCert,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strChangeIssueCerificate) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Changes on issued Certificate" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strChangeIssueCerificate,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProcedureChangedCert) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Procedure on changed certificates" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strProcedureChangedCert,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if ((_g = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objCertificateSample) === null || _g === void 0 ? void 0 : _g.strDocName) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Certificate Sample" }),
            children: (_jsx("a", { href: "#", onClick: (e) => {
                    e.preventDefault();
                    DownloadDoc(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strCertSampleDocRefId);
                }, children: (_h = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objCertificateSample) === null || _h === void 0 ? void 0 : _h.strDocName })),
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTrackIssuedCertOnWebsite) {
        certInfoItems.push({
            label: _jsx(Typography.Text, { children: "Track Issued Certificate on Website" }),
            children: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strTrackIssuedCertOnWebsite,
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    if (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolBomLinked) {
        genRegInfoItems.push({
            label: '',
            children: (_jsx("div", { style: { textAlign: 'right', padding: '0px' }, children: _jsx(Row, { justify: "end", style: { marginTop: 10 }, children: _jsxs(Col, { children: ["click\u00A0", _jsx(Link, { to: `/certificates?show-link=${objRegulatoryInfo.strEncodeSumRegId}&T=RI`, target: "_blank", style: { color: 'blue' }, children: "here" }), "\u00A0to view linked certificates"] }) }) })),
            span: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
        });
    }
    const standRegColumns = [
        {
            title: 'Classification',
            width: 50,
            dataIndex: 'classification',
            key: 'classification',
            render: (text, record) => record.intClassification === 1
                ? 'Standard'
                : record.intClassification === 2
                    ? 'Regulation'
                    : 'Supporting'
        },
        {
            title: 'Status',
            width: 50,
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => record.objStandRegStatus.strLongDesc
        },
        {
            title: 'Subject',
            width: 200,
            dataIndex: 'subject',
            key: 'subject',
            render: (text, record) => _jsx("div", { children: record.strSubject })
        },
        {
            title: 'Overview',
            width: 400,
            dataIndex: 'overview',
            key: 'overview',
            render: (text, record) => _jsx("div", { children: record.strOverview })
        },
        {
            title: 'Attachments',
            width: 150,
            dataIndex: 'attachments',
            key: 'attachments',
            render: (text, record) => { var _a; return (_a = record.objStandardRegAttachment) === null || _a === void 0 ? void 0 : _a.strDocName; }
        }
    ];
    const regFreqBandsColumns = [
        {
            title: 'Application type',
            // width: 80,
            dataIndex: 'appltype',
            key: 'appltype',
            render: (text, record) => { var _a; return (_a = record.objRegApplicationType) === null || _a === void 0 ? void 0 : _a.strLongDesc; }
        },
        {
            title: 'Frequency Bands',
            // width: 80,
            dataIndex: 'freqbands',
            key: 'freqbands',
            render: (text, record) => _jsx(Typography.Text, { children: record.strFreqBands })
        },
        {
            title: 'Max Strength/RF output power',
            // width: 100,
            dataIndex: 'maxstrength',
            key: 'maxstrength',
            render: (text, record) => _jsx(Typography.Text, { children: record.strMaxStrengthRFOutputPower })
        },
        {
            title: 'Max Bandwidth',
            // width: 100,
            dataIndex: 'maxbandwidth',
            key: 'maxbandwidth',
            render: (text, record) => _jsx(Typography.Text, { children: record.strMaxBandwidth })
        },
        {
            title: 'Harmonized Standard Reference',
            // width: 120,
            dataIndex: 'harmonizedref',
            key: 'harmonizedref',
            render: (text, record) => _jsx(Typography.Text, { children: record.strHarmonizedStandRef })
        },
        {
            title: (_jsx("div", { dangerouslySetInnerHTML: {
                    __html: 'Remarks (Emission type,<br/>duty cycle,<br/>other restrictions)'
                } })),
            // width: 150,
            dataIndex: 'remarks',
            key: 'remarks',
            render: (text, record) => (_jsx("div", { dangerouslySetInnerHTML: { __html: record.strRemarks || '' } }))
        }
    ];
    const getItems = () => {
        var _a;
        const items = [
            {
                key: '1',
                label: (_jsxs(Space, { children: [_jsx(FolderOutlined, {}), _jsx(Typography.Text, { strong: true, children: "General Regulatory Information" })] })),
                children: (_jsx(_Fragment, { children: ((_a = applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolRequirementSummaryDetailsPageGeneralInformation) ? (_jsx(Descriptions, { labelStyle: { width: '25%', fontWeight: 600 }, bordered: true, items: loading ? loadingItems : genRegInfoItems })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this information. Kindly reach out to BV contact for the same.", type: "info", showIcon: true })) })),
            },
        ];
        // Adding Procedure section if `boolCheckProcedureDetailsEmpty` is false
        if (!(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolCheckProcedureDetailsEmpty)) {
            items.push({
                key: '2',
                label: (_jsxs(Space, { children: [_jsx(SettingOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Procedure" })] })),
                children: (_jsx(_Fragment, { children: (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolIsCountryCombination) ? (_jsx(Descriptions, { labelStyle: { width: '25%', fontWeight: 600 }, bordered: true, items: loading ? loadingItems : procedureItems })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this information. Kindly reach out to BV contact for the same.", type: "info", showIcon: true })) })),
            });
        }
        // Adding Labeling Information section if `boolCheckLabelInfoDetailsEmpty` is false
        if (!(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolCheckLabelInfoDetailsEmpty)) {
            items.push({
                key: '3',
                label: (_jsxs(Space, { children: [_jsx(InfoCircleOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Labeling Information" })] })),
                children: (_jsx(_Fragment, { children: (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolIsCountryCombination) ? (_jsx(Descriptions, { labelStyle: { width: '25%', fontWeight: 600 }, bordered: true, items: loading ? loadingItems : labelingInfoItems })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this information. Kindly reach out to BV contact for the same.", type: "info", showIcon: true })) })),
            });
        }
        // Adding Certificate Information section if `boolCertInfoDetailsEmpty` is false
        if (!(objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolCertInfoDetailsEmpty)) {
            items.push({
                key: '4',
                label: (_jsxs(Space, { children: [_jsx(SafetyCertificateOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Certificate Information" })] })),
                children: (_jsx(_Fragment, { children: (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolIsCountryCombination) ? (_jsx(Descriptions, { labelStyle: { width: '25%', fontWeight: 600 }, bordered: true, items: loading ? loadingItems : certInfoItems })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this information. Kindly reach out to BV contact for the same.", type: "info", showIcon: true })) })),
            });
        }
        // Adding Standards & Regulations section if `lstStandardRegulationDetails` is not null
        if ((objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.lstStandardRegulationDetails) != null) {
            items.push({
                key: '5',
                label: (_jsxs(Space, { children: [_jsx(RadiusUpleftOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Standards & Regulations" })] })),
                children: (_jsx(_Fragment, { children: (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.boolIsCountryCombination) ? (_jsx(Table, { dataSource: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.lstStandardRegulationDetails, columns: standRegColumns, pagination: false, loading: loading })) : (_jsx(Alert, { message: "Want to view details? Please Upgrade your plan to get access to this information. Kindly reach out to BV contact for the same.", type: "info", showIcon: true })) })),
            });
        }
        // Adding Regulated Frequency Bands section
        if ((objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.lstRegFreqBandsDetails) != null) {
            items.push({
                key: '6',
                label: (_jsxs(Space, { children: [_jsx(CheckCircleOutlined, {}), _jsx(Typography.Text, { strong: true, children: "Regulated Frequency Bands" })] })),
                children: (_jsxs(_Fragment, { children: [_jsx("div", { style: { overflowX: 'auto' }, children: _jsx(Table, { dataSource: objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.lstRegFreqBandsDetails, columns: regFreqBandsColumns, pagination: false, loading: loading, scroll: { x: 'max-content' } }) }), _jsx("style", { children: `
              @media (max-width: 767px) {
                .ant-table-wrapper {
                  overflow-x: auto;
                }
              }
            ` })] })),
            });
        }
        return items;
    };
    const mapAreas = [
        {
            coords: '217,143,5',
            alt: 'BV CPS US Inc.',
            email: 'info@us.bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '207,150,5',
            alt: 'BV CPS US Inc.',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        { coords: '431,187,5', alt: 'BV LCIE France', email: 'contact@lcie.fr', category: 'testing' },
        {
            coords: '440,177,5',
            alt: 'BV LCIE France',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '492,147,5',
            alt: 'BV 7Layers Germany',
            email: 'cps.tech.emea@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '697,227,3',
            alt: 'BV Guangzhou',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '702,217,3',
            alt: 'BV Guangzhou',
            email: 'bvLCIEreception.GZ@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '708,230,3',
            alt: 'BV Dongguan',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '712,219,3',
            alt: 'BV Dongguan',
            email: 'customerservice.dg@cn.bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '739,230,3',
            alt: 'BV Taiwan',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '744,219,3',
            alt: 'BV Taiwan',
            email: 'service.adt@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '732,181,3',
            alt: 'BV Shanghai',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '740,184,3',
            alt: 'BV Shanghai',
            email: 'BVLCIEMKT@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '771,155,3',
            alt: 'BV Korea',
            email: 'CPSEE.ANY@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '779,160,3',
            alt: 'BV Korea',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '832,156,3',
            alt: 'BV Japan',
            email: 'eaw.yok@bureauveritas.com',
            category: 'testing'
        },
        {
            coords: '842,148,3',
            alt: 'BV Japan',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        },
        {
            coords: '482,155,5',
            alt: 'BV 7Layers Germany',
            email: 'GMA.service@bureauveritas.com',
            category: 'approval'
        }
    ];
    const openPopup = (area) => {
        const [x, y] = area.coords.split(',').map(Number);
        setTooltipContent(area);
        setTooltipPosition({ left: x, top: y });
    };
    const closePopup = () => {
        setTooltipContent(null);
        setTooltipPosition(null);
    };
    return (_jsx("div", { style: { userSelect: 'none' }, children: _jsxs(Card, { title: 'Requirement Summary', extra: (objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.intValidVerCount) > 1 ? (_jsx(Link, { to: `/reg-info-compare/${objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.strEncodeSumRegId}`, target: "_blank", children: "Compare Version" })) : (''), children: [_jsx(Breadcrumb, { style: { marginBottom: '10px' }, items: [
                        {
                            title: _jsx(Typography.Text, { children: (_j = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLuCountry) === null || _j === void 0 ? void 0 : _j.strLongDesc })
                        },
                        {
                            title: _jsx(Typography.Text, { children: (_k = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLuServiceCode) === null || _k === void 0 ? void 0 : _k.strLongDesc })
                        },
                        {
                            title: _jsx(Typography.Text, { children: ((_l = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLuProductType) === null || _l === void 0 ? void 0 : _l.strLongDesc) != null
                                    ? (_m = objRegulatoryInfo === null || objRegulatoryInfo === void 0 ? void 0 : objRegulatoryInfo.objLuProductType) === null || _m === void 0 ? void 0 : _m.strLongDesc
                                    : 'All Products' })
                        }
                    ] }), _jsx(WatermarkComponent, { children: _jsx(Collapse, { bordered: false, 
                        // ghost
                        defaultActiveKey: ['1', '2', '3', '4', '5', '6'], items: getItems() }) }), _jsx(Divider, {}), _jsx(Row, { justify: "center", children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 18, xl: 16, xxl: 14, children: _jsxs("div", { style: {
                                textAlign: 'center',
                                paddingBottom: 30,
                                borderBottom: '2px solid #EEEDE7',
                                marginBottom: 30,
                                position: 'relative'
                            }, children: [_jsx("img", { src: mapImage, width: "100%", height: "auto", alt: "Contacts", useMap: "#eawmap" }), _jsx("map", { name: "eawmap", children: mapAreas.map((area, index) => (_jsx("area", { shape: "circle", coords: area.coords, alt: area.alt, style: { cursor: 'pointer' }, onMouseOver: () => openPopup(area), onMouseOut: closePopup }, index))) }), tooltipContent && tooltipPosition && (_jsx(Tooltip, { title: _jsxs("div", { children: [_jsx("strong", { children: tooltipContent.alt }), _jsx("br", {}), _jsx("a", { href: `mailto:${tooltipContent.email}`, children: tooltipContent.email })] }), open: true, placement: "top", children: _jsx("div", { style: {
                                            position: 'absolute',
                                            left: tooltipPosition.left - 10,
                                            top: tooltipPosition.top - 25,
                                            pointerEvents: 'none'
                                        }, children: _jsx("span", { style: {
                                                display: 'inline-block',
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                                color: 'white',
                                                fontSize: '12px'
                                            }, children: tooltipContent.alt }) }) }))] }) }) }), _jsx(Divider, {}), _jsx(Disclaimer, { boolRegulationLibraryDetailPageDisclimer: true })] }) }));
};
export default RegulationInformation;
